import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import Center from "../utils/Center";
import Kebab from "../utils/Kebab";
import { areYouSure, trackEvent } from "../helpers";
import { useCampaigns } from "../../state/Storage";
import { deleteCampaign } from "../../apis/firebase";
import { closePopUp, showLoadingPopUp } from "../utils/Overlay";
import Pagination from "../utils/Pagination";
import Activity from "../utils/icons/Activity";
import JobSnapshotsGraph from "./JobSnapshotsGraph";

export default function CampaignsList() {
  const [error, setError] = useState<Error | null>(null);
  const history = useHistory();
  const [campaigns, sync, pagination] = useCampaigns();

  const sortedCampaigns = campaigns.sort((a, b) =>
    a.createdAt.toDate().getTime() < b.createdAt.toDate().getTime() ? 1 : -1
  );

  return (
    <div className="layout mt3">
      <h2 className="tac">Campaigns</h2>
      <p className="tac mb3">Your content.</p>
      <Center className="tac mt3" width={300}>
        <button
          className="primary"
          onClick={() => {
            trackEvent("add-new-campaign");
            history.push("/campaigns/add");
          }}
        >
          Add new campaign
        </button>
      </Center>
      {error && <div className="error mt1">{error}</div>}
      <div className="grid grid2 mt3 mb2 gap2 top-bordered">
        {sortedCampaigns.map((campaign) => {
          return (
            <div key={campaign.id} data-id={campaign.id} className="rel">
              <h3>
                <button
                  type="button"
                  className="reset as-link ib tal mr05"
                  onClick={() =>
                    history.push(`/campaigns/edit/${campaign.id}/publishing`)
                  }
                >
                  {campaign.title}
                </button>
              </h3>
              <div className="mb1 mt05">{formatStats(campaign)}</div>
              <Kebab
                style={{ top: "20px", right: "8px" }}
                links={[
                  {
                    label: "Edit",
                    onClick: () =>
                      history.push(`/campaigns/edit/${campaign.id}/content`),
                  },
                  {
                    label: "Delete",
                    onClick: areYouSure(
                      async () => {
                        try {
                          showLoadingPopUp("Deleting. Please wait.");
                          await deleteCampaign(campaign);
                          sync();
                          closePopUp();
                        } catch (err) {
                          console.error(err);
                          setError(new Error(""));
                        }
                      },
                      <>
                        <h3 className="tac">Deleting a post. Are you sure?</h3>
                        <small className="block mb1">
                          Deleting a campaign also means deleting all the
                          content attached to it.
                        </small>
                      </>
                    ),
                  },
                ]}
              />
              <JobSnapshotsGraph stats={campaign.stats} height={200} />
            </div>
          );
        })}
      </div>
      <Pagination pagination={pagination} />
    </div>
  );
}

function formatStats(post: Post) {
  if (post.stats) {
    return (
      <>
        <Activity size={12} /> {post.stats.engagements} user engagement
        {post.stats.engagements !== 1 ? "s" : ""}
      </>
    );
  }
  return null;
}
